import * as Sentry from "@sentry/browser";
import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { t } from "i18next";
import api from "../../../api";
import urls from "../../../urls";
import { queryWithPollResponse } from "../../../utils/api-utils";
import type { Person } from "../../../utils/backend-types";

export function useImportPersonFromMastr(
  taskId: string,
  options?: Partial<UseQueryOptions<Person>>
) {
  return useQuery({
    queryKey: ["person-from-mastr", { taskId }],
    queryFn: () => fetchPersonFromMastr(taskId),
    ...options
  });
}

async function fetchPersonFromMastr(taskId: string) {
  const url = urls.api.getCreatedPersonFromMastr(taskId);
  const response = await queryWithPollResponse<Person>(() => api.get(url));

  if (!response.data) {
    Sentry.captureMessage(
      `useImportPersonFromMastr: response missing data for taskId ${taskId}`
    );
    throw new Error(t("errors.ServerError"));
  }

  return response.data;
}
